export interface Section {
  id: string
  productId: string
  title: string
  slug: string
}

export enum CONTENT_TYPE {
  MARKDOWN = 'markdown',
  HTML = 'html',
  API_URL = 'apiUrl',
  GRAPHQL = 'graphql',
  MCP = 'mcp',
  A2A = 'a2a',
  GRPC = 'grpc',
}

export const DEFINITION_MARKDOWN_TYPES = [
  CONTENT_TYPE.GRAPHQL,
  CONTENT_TYPE.MCP,
  CONTENT_TYPE.A2A,
  CONTENT_TYPE.GRPC,
] as const

export type DefinitionMarkdownType = typeof DEFINITION_MARKDOWN_TYPES[number]
